import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Data } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class ParamsService {

  constructor() {
  }

  getParamById(id: string, route: ActivatedRouteSnapshot): string {
    if (route.params[id]) {
      return route.params[id];
    }
    if (route.parent) {
      return this.getParamById(id, route.parent);
    }
    return null;
  }

  /**
   * Get data from routes by id
   *
   * @param id
   * @param route
   * @returns
   */
  getRouteDataById(id: string, route: ActivatedRouteSnapshot): Data {
    if (route.data[id]) {
      return route.data[id];
    }
    if (route.children) {
      for (const children of route.children) {
        return this.getRouteDataById(id, children);
      }
    }
    return null;
  }
}
